import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { merchantThemes, fonts } from '../../Variable'

export const InputWrapperStyle = styled.label`
	display: flex;
	flex-flow: row wrap;
	align-content: flex-start;
	align-items: flex-start;
	justify-content: space-between;
	position: relative;
	width: 100%;
`
export const Error = styled.div`
	padding-top: ${rem(3)};
	font-size: ${rem(12)};
	line-height: 1;
	color: ${({ theme }) => theme.color.redOne};
`
export const InputStyle = styled.input`
	display: block;
	width: 100%;
	min-width: 0;
	flex: 0 0 100%;
	max-width: 100%;
	height: ${rem(50)};
	border-bottom: 1px solid ${({ theme }) => theme.color.grayFour};
	background-color: transparent;
	transition: all 0.3s;
	font-size: ${rem(16)};
	line-height: ${rem(18)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			border: 1px solid ${({ theme }) => theme.color.primary};
			padding: ${rem(0, 15)};
			font-family: ${fonts.MonumentGrotesk};
			border-radius: ${rem(32)};
			height: ${rem(33)};
			font-size: ${rem(14)};
		`}

	&::placeholder {
		font-size: ${rem(16)};
		line-height: ${rem(50)};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-size: ${rem(14)};
			`}

		${(p) =>
			p.placeholderNotBold &&
			css`
				font-weight: 400;
			`}
	}
`
